/* eslint-disable no-return-await, no-console, no-param-reassign, no-trailing-spaces */
import axios from 'axios';
import store from '../store';
import helper from '@/_libs/helper';


const notification = {
  async list() {
    return await helper.call('notification.list', {
      success: true,
      data: [],
    }, async () => {
      const res = await axios.get(helper.path('notifications'));

      res.data = res.data.sort((a, b) => {
        console.log(`${a.id} vs ${b.id}`);
        return b.id - a.id;
      });
      store.commit('setNotifications', res.data);
      console.log(`${store.getters.orderNotifications.length} notification(s) loaded into store`);
      return res;
    });
  },
  async remove(notiId, orderId) {
    return await helper.call('notification.remove', {
      success: true,
      data: [],
    }, 
    async () => {
      try {
        const res = await axios.delete(helper.path(`notifications/${notiId}`));
  
        // remove successful -> remove in store also
        if (res.status === 201) {
          store.commit('removeUnreadNotification', { notiId, orderId });
        }
  
        return res;
      } catch (e) {
        throw e;
      }
    });
  },
  async markAsRead(notiId, orderId) {
    return await helper.call('notification.read', {
      success: true,
      data: [],
    }, 
    async () => {
      try {
        const res = await axios.post(helper.path(`notifications/${notiId}/read`));
  
        // // remove successful -> remove in store also
        if (res.status === 201) {
          store.commit('removeUnreadNotification', { notiId, orderId });
        }
  
        return res;
      } catch (e) {
        throw e;
      }
    });
  },
};

export default notification;
